import React from 'react';
import { styled } from 'styled-components';
import { Button } from '/imports/ui/Button';
import { css } from '/imports/ui/css';

const DividerTabsStyled = styled.div`
  margin-top: 1rem;
  display: flex;
  /* Tabs share out the row up to 12rem each, shrink to their labels when it gets tight, and wrap past
     that rather than run off the strip. min-width: fit-content is what makes them wrap instead of
     compressing below their labels and ellipsising. */
  flex-wrap: wrap;
  row-gap: 0.25rem;
  background-color: ${css.white};
  border-bottom: 2px solid ${css.primaryColor};
  .btn {
    flex: 1 1 auto;
    min-width: fit-content;
    max-width: 12rem;
    white-space: nowrap;
    border-radius: 0;
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
    border-color: ${css.grey7};
    background-color: ${css.grey7};
    color: ${css.grey3};
    &.active {
      color: ${css.white};
      background-color: ${css.primaryColor};
      border-bottom: 4px solid ${css.primaryColor};
    }
  }
`;

interface DividerTab {
  id: string;
  label: string;
}

interface DividerTabsProps {
  tabs: DividerTab[];
  activeTab: string;
  onTabChange: (tab: string) => void;
}

/** Horizontal tab strip rendering a button per tab and highlighting the active one. */
export const DividerTabs = (props: DividerTabsProps) => (
  <DividerTabsStyled className="main-tabs">
    {props.tabs.map((tab) => (
      <Button
        key={tab.id}
        id={`tab-${tab.id}`}
        className={`btn primary${props.activeTab === tab.id ? ' active' : ''}`}
        onClick={() => props.onTabChange(tab.id)}
      >
        {tab.label}
      </Button>
    ))}
  </DividerTabsStyled>
);
